import styled from '@emotion/styled'
import theme from '../../constants/theme'

export const RatingRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
}))

export const RatingButton = styled('button')(({ active }) => ({
  width: '38px',
  height: '38px',
  borderRadius: '50%',
  border: `1px solid ${active ? theme.brandColorOrange : '#d7dde4'}`,
  backgroundColor: active ? theme.brandColorOrange : theme.white,
  color: active ? theme.white : theme.talentinoSecondaryGray,
  fontFamily: 'PoppinsMedium',
  fontSize: '13px',
  cursor: 'pointer',
  transition: 'all 0.15s ease',
}))

export const PillRow = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
}))

export const Pill = styled('button')(({ active }) => ({
  padding: '6px 14px',
  borderRadius: '99px',
  border: `1px solid ${active ? theme.brandColorOrange : '#d7dde4'}`,
  backgroundColor: active ? theme.talentinoLightBlueBackground : theme.white,
  color: active ? theme.brandColorOrange : theme.talentinoTextGray,
  fontSize: '12px',
  fontFamily: 'PoppinsMedium',
  cursor: 'pointer',
  transition: 'all 0.15s ease',
}))

export const CheckRow = styled('label')(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',
  cursor: 'pointer',
  marginBottom: '4px',
}))
